import { useCharacterFormLogic } from "./useCharacterFormLogic";

export const useOtpSubmit = () => {
  // Use the consolidated hook with 'otp' mode
  const result = useCharacterFormLogic("otp");

  // Determine readiness based on the hook's state
  const isReady =
    Array.from(result.characterNames.values()).every(
      (name) => name.length > 0
    ) && result.characterNames.size === result.characters.length;

  // Return the exact same interface as before for backward compatibility
  return {
    // Data
    playerCharacters: result.characters,
    characters: result.characterNames,
    mature: result.mature,
    isSolo: result.isSolo,
    gameSettings: result.settings,

    // Computed values
    isReady,
    isAllAges: result.isAllAges,
    subHeaders: result.subHeaders,
    submitText: result.submitText,
    titles: result.titles,

    // Actions
    handleChange: result.handleChange,
    handleMature: result.handleMature,
    createPlayerAction: result.createPlayerAction,
  };
};
